import './styles/where-to-buy.scss';

import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import MapsLocator from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/MapsLocator/MapsLocator';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { TitleBanner } from '../components/Primitives';
import buttonArrow from '@progymedia/gatsby-theme-boutik-ecommerce/src/images/icons/Icon-Fleche.svg';
import { graphql } from 'gatsby';
import { partnersFactory } from '../helpers/partnerLocatorHelper';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query FindRetailer {
        metadata: allProductsJson(
            filter: { code: { eq: "drolet_find-retailer" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    banniere_desktop {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                    banniere_mobile {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                }
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        partnerInstallers: allPartnerInstaller {
            nodes {
                SBIAccountNumber
                id
                AccountName
                Phone
                Email
                ShippingStreet
                ShippingCity
                ShippingPostalCode
                ShippingState
                ShippingCountry
                Website
                fields {
                    Latitude
                    Longitude
                }
            }
        }
    }
`;

export default function FindRetailer({
    data,
}: {
    data: Queries.FindRetailerQuery;
}) {
    const { t } = useTranslation('pages');
    const { currentLocale } = usePageLocalization();
    const metadataAttributes = data?.metadata?.nodes[0]?.attributes;
    const metadata = {
        title: metadataAttributes?.meta_title?.values?.[0]?.[currentLocale],
        description:
            metadataAttributes?.meta_description?.values?.[0]?.[currentLocale],
    };
    const partnerInstallerNodes = data?.partnerInstallers?.nodes;
    const isMobile = useMobileDetect().isMobile();
    const responsiveImages = data?.metadata?.nodes?.[0]?.fields;
    const desktopImage =
        responsiveImages?.banniere_desktop?.[0]?.childImageSharp
            ?.gatsbyImageData;
    const mobileImage =
        responsiveImages?.banniere_mobile?.[0]?.childImageSharp
            ?.gatsbyImageData;
    const pageTitle = data?.metadata?.nodes?.[0]?.title?.[currentLocale];

    return (
        <Layout>
            <SEO
                title={metadata?.title ?? ''}
                description={metadata?.description ?? ''}
            />
            <TitleBanner
                className='accessory-listing-titlebanner'
                imageData={isMobile ? mobileImage : desktopImage}
                title={pageTitle ?? ''}
            />
            <div className='where-to-buy container'>
                <div className='row'>
                    <div id='primary'>
                        <MapsLocator
                            installers={partnersFactory(partnerInstallerNodes)}
                            traduction={{
                                inputPlaceholder: t('where-to-buy.postcode'),
                                buttonLabel: t('where-to-buy.button-label'),
                                results: t('where-to-buy.results'),
                                noAddress: t('where-to-buy.no-address-result'),
                                noEmpty: t('where-to-buy.cannot-be-empty'),
                            }}
                            buttonArrow={buttonArrow}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
}
